module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp12_8023.3a866ac8.png";